export default __webpack_public_path__ + "static/media/medium.a3499596.svg";